import { Component, Input } from '@angular/core';
import { Network } from '@ionic-native/network';
import { Subscription } from 'rxjs';

@Component({
  selector: 'radio',
  templateUrl: 'radio.html'
})
export class RadioComponent {

  @Input() link: string;
  @Input() titulo: string;
  private stream = new Audio();
  private readonly numeroBarras = 20;
  private subscriptionConexao: Subscription;
  private isTocando: boolean;
  private intervaloVerificacaoAudio: number;
  private tempoAntigoRadio: number;

  constructor(private network: Network) {
    this.isTocando = false;
    this.subscriptionConexao = this.montarObservavelConexaoRadio();
    this.intervaloVerificacaoAudio = this.verificarSeAudioParou();
  }

  ngOnInit() {
    this.iniciarAudioPlayer();
    this.stream.ontimeupdate = () => {
      this.tempoAntigoRadio = this.stream.currentTime;
    } 
  }
  
  ngOnDestroy() {
    this.pause();
    this.subscriptionConexao.unsubscribe();
    clearInterval(this.intervaloVerificacaoAudio);
  }

  private async iniciarAudioPlayer() {
    if (!this.link && !this.titulo) {
     // const radio = await this.brcomService.getDadosRadio();
      this.link = "http://107.191.38.218:9148/live";
      this.titulo = "Rádio APRASC (ao vivo)";
    }
    this.stream.preload = "metadata";
  }

  /**
   * Reseta o objeto de áudio e o inicia caso o mesmo esteja pausado ou exista um erro na transmição da stream. 
   * Modifica a varivel isTocando para 'true'. Igonora eventuais erros.
   */
  private play() {
    if (this.isPauseAtivo() || this.hasErroAoTocarRadio()) {
      this.isTocando = true;
      this.stream.src =  this.link;
      this.stream.load();
      this.stream.play().catch(()=>{});
    }
  }

  /**
   * Caso o áudio estiver ativo este método o pausa, modificando a variavel isTocando para 'false' e removendo
   * a fonte de streaming para evitar buffering desnecessário.
   */
  public pause() {
    if (this.isPlayAtivo()) {
      this.isTocando = false;
      this.stream.pause();
      this.stream.src = "";
      this.stream.load();
    }
  }

  /**
   * Cria um intervalo que a cada 2 segundos verifica enventuais erros de conexão da rede durante o streaming, 
   * caso encontre tenta inciar o áudio.
   * 
   * @returns {number}
   */
  private verificarSeAudioParou(): number {
    return window.setInterval(() => {
      if (this.hasErroAoTocarRadio()) {
        console.log("ERRO - Tentando iniciar a rádio novamente...");
        this.play();
      }
    }, 2000);
  }

  /**
   * Verifica se existe algum erro durante a transmição de áudio.
   * 
   * @returns {boolean}
   */
  private hasErroAoTocarRadio():boolean {
    const isAudioParado = this.tempoAntigoRadio === this.stream.currentTime;
    const hasAudioAcabadoDeSerIniciado = this.stream.currentTime === 0;
    
    return isAudioParado && !hasAudioAcabadoDeSerIniciado && this.isPlayAtivo() && this.isConectadoInternet();
  }

  private montarObservavelConexaoRadio():Subscription {
    return this.network.onConnect().subscribe(()=> {
      if (this.isPlayAtivo()) {
        this.play();
      }
    })
  }

  /**
   * Cria um array com o tamanho do valor da constante 'numeroBarras' preenchido com zeros.
   */
  public getNumBarras():any {
    return Array(this.numeroBarras).fill(0)
  }

  public isPauseAtivo():boolean {
    return !this.isTocando;
  }

  public isPlayAtivo(): boolean {
    return this.isTocando
  }

  public isConectadoInternet():boolean {
    return this.network.type !== 'unknown' && this.network.type !== 'none'
   }

}



// WEBPACK FOOTER //
// ./src/components/radio/radio.ts